import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FeedbackRating } from '../../models/chat.model';
import { FeedbackService } from '../../services/feedback.service';
import { UserInfoService } from '../../../../../../../../src/app/services/user-info.service';

interface FeedbackCategory {
	label: string;
	selected: boolean;
}

@Component({
	selector: 'app-feedback-rating',
	templateUrl: './feedback-rating.component.html',
	styleUrls: ['./feedback-rating.component.scss'],
})
export class FeedbackRatingComponent {
	@Input() messageId!: string;
	@Input() currentFeedback?: FeedbackRating;
	@Output() feedbackSubmitted = new EventEmitter<FeedbackRating>();

	private internalUserGUID: string = '';

	showFeedbackForm = false;

	readonly onThumbsUpAction = () => this.onThumbsUp();
	readonly onThumbsDownAction = () => this.onThumbsDown();

	categories: FeedbackCategory[] = [
		{ label: 'Inaccurate', selected: false },
		{ label: 'Incomplete', selected: false },
		{ label: 'Not relevant', selected: false },
	];

	constructor(
		private feedbackService: FeedbackService,
		private userService: UserInfoService
	) {}

	async ngOnInit(): Promise<void> {
		this.internalUserGUID = (await this.userService.getCurrentLoggedInUser()).internalUserGUID ?? '';
	}

	get isThumbsUp(): boolean {
		return this.currentFeedback?.rating === 'thumbs_up';
	}

	get isThumbsDown(): boolean {
		return this.currentFeedback?.rating === 'thumbs_down';
	}

	onThumbsUp(): void {
		const feedback: FeedbackRating = { rating: 'thumbs_up', ratedAt: new Date() };
		this.feedbackService.submitFeedback(this.messageId, 'thumbs_up', this.internalUserGUID);
		this.feedbackSubmitted.emit(feedback);
		this.showFeedbackForm = false;
	}

	onThumbsDown(): void {
		const feedback: FeedbackRating = { rating: 'thumbs_down', ratedAt: new Date() };
		this.feedbackService.submitFeedback(this.messageId, 'thumbs_down', this.internalUserGUID);
		this.feedbackSubmitted.emit(feedback);
		this.showFeedbackForm = true;
	}

	toggleCategory(cat: FeedbackCategory): void {
		cat.selected = !cat.selected;
	}

	submitDetailedFeedback(): void {
		const selected = this.categories.filter((c) => c.selected).map((c) => c.label);
		const comment = selected.join(', ');
		const feedback: FeedbackRating = { rating: 'thumbs_down', comment, ratedAt: new Date() };
		this.feedbackService.submitFeedback(this.messageId, 'thumbs_down', this.internalUserGUID, comment);
		this.feedbackSubmitted.emit(feedback);
		this.showFeedbackForm = false;
	}
}
